import type { ReactNode } from "react";
import { CorrectIcon } from "src/assets/Icons";
import Tag from "src/components/Tag/Tag";
import i18n from "src/i18n";
import { formatDate } from "src/utility/time";
import type { DataMap } from "src/Modules/UserHistory/pages/OrdersList/components/OrderCard/constants";
import { STATUS_MAP, UNKNOWN_STATUS, type OrderStatusKey } from "src/Modules/UserHistory/pages/OrdersList/constants";
import type { BookingDetailResult } from "src/store/apis/Hotels";

export const hotelOrderDataMap: DataMap = {
  bookingReferenceId: {
    get label() {
      return i18n.t("UserHistory.orderDetails.orderId");
    },
    value: () => null,
  },
  bookingDate: {
    get label() {
      return i18n.t("UserHistory.orderDetails.bookingDate");
    },
    value: (val) => (val ? formatDate(val, "YYYY-MM-DD hh:mm A") : "-"),
  },
  confirmationNumber: {
    get label() {
      return i18n.t("UserHistory.orderDetails.providerRef");
    },
    value: (val) => val ?? "-",
  },
};

export type CancellationTag = { label: string; tone: "success" | "danger" };

type CancellationTagConfig = {
  select: (tag: CancellationTag) => boolean;
  style: string;
  display: (tag: CancellationTag) => ReactNode;
};

export const CANCELLATION_TAG_CONFIG: CancellationTagConfig[] = [
  {
    select: (tag) => tag.tone === "success",
    style: "bg-background-success text-font-success",
    display: (tag) => (
      <>
        <CorrectIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
        {tag.label}
      </>
    ),
  },
  {
    select: (tag) => tag.tone === "danger",
    style: "bg-background-danger text-font-danger",
    display: (tag) => tag.label,
  },
];

export function getHotelBookingSummaryCardData(data: BookingDetailResult | undefined) {
  const status = STATUS_MAP[data?.orderStatus as OrderStatusKey] ?? UNKNOWN_STATUS;
  return {
    data: data as Record<string, any>,
    title: i18n.t("UserHistory.flight.bookingData"),
    orderId: data?.bookingReferenceId,
    tag: <Tag label={status.label} color={status.color} className="rounded-full p-1 px-5 text-sm outline outline-current" />,
  };
}
